<template>
  <footer class="footer px-4">
    <b-row align-v="center" class="justify-content-lg-between">
      <b-col lg="6">
        <div class="copyright text-center text-lg-left text-muted">
          © {{year}} <a href="/" class="font-weight-bold ml-1">Buka Kasir</a>
        </div>
      </b-col>
      <b-col lg="6">
        <b-nav align="center" class="nav-footer justify-content-lg-end text-white">
          <b-nav-item href="https://www.bukakasir.com"  target="_blank">
            Buka Kasir
          </b-nav-item>
          <b-nav-item href="https://www.bukakasir.com/about_us" target="_blank">
           About Us
          </b-nav-item>
        </b-nav>
      </b-col>
    </b-row>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style></style>
